import React from "react";
import styles from "./NewTicketModal.module.css";
import { FiFileText, FiLock, FiPrinter, FiSmartphone } from "react-icons/fi";

const PASSWORD_TYPES = ["Poczta/o365", "ECM", "Do Komputera/AD"];
const PHONE_PROBLEM_TYPES = ["Instalacja aplikacji", "Brak PIN", "Awaria"];

export const buildTicketSubject = (category, fields) => {
  if (!category) {
    return "Zgłoszenie";
  }

  let subjectParts = [category.name];
  const type = Number(category.type);

  switch (type) {
    case 3:
      if (fields.passwordType) {
        subjectParts.push(fields.passwordType);
      }
      break;
    case 6:
      if (fields.phoneProblem) {
        subjectParts.push(fields.phoneProblem);
      }
      break;
    case 4:
      if (fields.printerNumber) {
        subjectParts.push(fields.printerNumber);
      }
      break;
    default:
      break;
  }

  return subjectParts.join(" - ");
};

export const buildTicketBody = (categoryType, fields) => {
  let bodyLines = [];
  const type = Number(categoryType);

  switch (type) {
    case 3:
      bodyLines.push(fields.passwordType || "Nie wybrano typu hasła");
      if (fields.additionalInfo) {
        bodyLines.push(fields.additionalInfo);
      }
      break;
    case 4:
      bodyLines.push(`Numer drukarki: ${fields.printerNumber || "Nie podano"}`);
      bodyLines.push(fields.description || "Brak opisu");
      break;
    case 6:
      bodyLines.push(fields.phoneProblem || "Nie wybrano problemu");
      bodyLines.push(fields.description || "Brak opisu");
      break;
    case 1:
    case 2:
    case 5:
    default:
      bodyLines.push(fields.description || "Brak opisu");
      break;
  }

  if (categoryType === null) {
    bodyLines = [fields.description || "Brak opisu"];
  }

  return bodyLines.join("\n\n");
};

export const renderDynamicFields = (
  categoryType,
  dynamicFields,
  handleDynamicFieldChange
) => {
  if (categoryType === undefined) {
    return null;
  }

  const type = Number(categoryType);

  switch (type) {
    case 3:
      return (
        <>
          <div className={styles.formGroup}>
            <label htmlFor="passwordType">
              <FiLock /> Jakiego hasła dotyczy problem?
            </label>
            <select
              id="passwordType"
              name="passwordType"
              value={dynamicFields.passwordType || ""}
              onChange={handleDynamicFieldChange}
              required
            >
              <option value="" disabled>
                Wybierz...
              </option>
              {PASSWORD_TYPES.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="additionalInfo">
              <FiFileText /> Dodatkowe informacje (opcjonalnie)
            </label>
            <textarea
              id="additionalInfo"
              name="additionalInfo"
              value={dynamicFields.additionalInfo || ""}
              onChange={handleDynamicFieldChange}
              rows={5}
            />
          </div>
        </>
      );

    case 4:
      return (
        <>
          <div className={styles.formGroup}>
            <label htmlFor="printerNumber">
              <FiPrinter /> Numer drukarki
            </label>
            <input
              type="text"
              id="printerNumber"
              name="printerNumber"
              value={dynamicFields.printerNumber || ""}
              onChange={handleDynamicFieldChange}
              maxLength={50}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="description">
              <FiFileText /> Opis problemu
            </label>
            <textarea
              id="description"
              name="description"
              value={dynamicFields.description || ""}
              onChange={handleDynamicFieldChange}
              required
              rows={5}
            />
          </div>
        </>
      );

    case 6:
      return (
        <>
          <div className={styles.formGroup}>
            <label htmlFor="phoneProblem">
              <FiSmartphone /> Wybór problemu
            </label>
            <select
              id="phoneProblem"
              name="phoneProblem"
              value={dynamicFields.phoneProblem || ""}
              onChange={handleDynamicFieldChange}
              required
            >
              <option value="" disabled>
                Wybierz...
              </option>
              {PHONE_PROBLEM_TYPES.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="description">
              <FiFileText /> Opis problemu
            </label>
            <textarea
              id="description"
              name="description"
              value={dynamicFields.description || ""}
              onChange={handleDynamicFieldChange}
              required
              rows={5}
            />
          </div>
        </>
      );

    case 1:
    case 2:
    case 5:
    default:
      return (
        <div className={styles.formGroup}>
          <label htmlFor="description">
            <FiFileText /> Opis problemu
          </label>
          <textarea
            id="description"
            name="description"
            value={dynamicFields.description || ""}
            onChange={handleDynamicFieldChange}
            required
            rows={8}
          />
        </div>
      );
  }
};
